import axios from 'axios';
import {API_URL} from './API_URL';

// this class for login and provide user data beside adding it to session and veux store . 
class AuthService {
  login(ApplicantData) {
    return axios
        .post(API_URL + 'Security/login', {
        username: ApplicantData.Username + '@su',
        password: ApplicantData.Password
        })
        .then(response => {
           

        if (response.data.Token) {
          sessionStorage.setItem('user', JSON.stringify(response.data));
          return response.data;
        }
        if(response.data['0'].Token){
          sessionStorage.setItem('user', JSON.stringify(response.data['0']));
          return response.data['0'];
        }

       
      });
  }
  Externallogin(ApplicantData) {
    return axios
        .post(API_URL + 'Security/ExternalStudentLogin', {
        username: ApplicantData,
        //password: ApplicantData.Password
        })
        .then(response => {
           

        if (response.data.Token) {
          sessionStorage.setItem('user', JSON.stringify(response.data));
          return response.data;
        }
        if(response.data['0'].Token){
          sessionStorage.setItem('user', JSON.stringify(response.data['0']));
          return response.data['0'];
        }

        return  response
      });
  }
  logout() {
    sessionStorage.removeItem('user');
    sessionStorage.clear()
    localStorage.clear()
  }

  // register(user) {
  //   return axios.post(API_URL + 'Security/SignUp', {
  //     Email : user.Email ,
  //     FirstNameEN   :user. FirstNameEN ,
  //     LastNameEN      :user. LastNameEN ,
  //     BirthDate     : user.BirthDate ,
  //    NationalityId   :user. NationalityId ,
  //     NationID      : user.NationID ,
  //     GenderID      : user.GenderID 
  //   });
  // }
  register(user) {
    return axios.post(API_URL + 'Security/SignUP_Profile', user , {
      headers: {
      'Content-Type': 'multipart/form-data'
      }
    });
  }
  ChangePassword(userName , currentPassword , newPassword){
    return axios.post(API_URL + `ExternalLogin/ChangeMyPassword?userName=${userName}&currentPassword=${currentPassword}&newPassword=${newPassword}`)
  }
}

export default new AuthService();
